import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '請求書一覧',
  },
});

export const meta: PageMeta = {
  title: strings.title,
};
